import { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { useEnergyData } from './useEnergyData';
import { useDeviceData } from './useDeviceData';
import { usePageData } from './usePageData';
import { sendAnalytics } from './sendAnalytics';
import { selectEvents } from 'state/analytics/analytics-slice';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const useAnalytics = () => {
  const events = useSelector(selectEvents, shallowEqual);
  const pageData = usePageData();
  const journeyData = useDeviceData();
  const energyData = useEnergyData();
  const featureFlags = useFlags();

  useEffect(() => {
    const digitalData = {
      page: pageData,
      journey_data: journeyData,
      'data-energy': energyData,
      events: [...events],
      event: events[0],
      feature_flags: JSON.parse(JSON.stringify(featureFlags))
    };

    window.digitalData = digitalData;
    sendAnalytics(digitalData);
  }, [pageData, journeyData, energyData, events, featureFlags]);
};
